var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isInitializing)?_c('CycleDocumentsFilter',{attrs:{"text-content":_vm.textContent,"document-codes-filter":_vm.fields.documentCodesFilter},on:{"filter-change":_vm.updateFilterValues}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }